// extracted by mini-css-extract-plugin
export default {"ChooseTime":"ChooseTime_ChooseTime__dnnX7"};